import React, { useEffect, useState } from "react";
import { BellRing, BellOff, Send, Loader2, Smartphone } from "lucide-react";
import { toast } from "react-toastify";

import { Button } from "../ui/button";
import {
	statusPush,
	ativarPush,
	desativarPush,
	testarPush,
} from "../../push/pushNativo";

// Ativar/desativar as notificacoes push nativas neste aparelho. O toque no
// botao satisfaz a exigencia do iOS de que a permissao venha de um gesto do
// usuario. Cada aparelho/navegador assina o seu.

const NotificacoesPush = () => {
	const [status, setStatus] = useState("carregando");
	const [ocupado, setOcupado] = useState(false);

	const atualizar = async () => {
		try {
			setStatus(await statusPush());
		} catch {
			setStatus("sem-suporte");
		}
	};

	useEffect(() => {
		atualizar();
	}, []);

	const ativar = async () => {
		setOcupado(true);
		try {
			await ativarPush();
			toast.success("Notificacoes ativadas neste aparelho.");
		} catch (e) {
			toast.error(e?.message || "Nao foi possivel ativar.");
		}
		await atualizar();
		setOcupado(false);
	};

	const desativar = async () => {
		setOcupado(true);
		try {
			await desativarPush();
			toast.success("Notificacoes desativadas neste aparelho.");
		} catch (e) {
			toast.error(e?.message || "Erro ao desativar.");
		}
		await atualizar();
		setOcupado(false);
	};

	const testar = async () => {
		setOcupado(true);
		try {
			await testarPush();
			toast.success("Enviei um teste — deve chegar em instantes.");
		} catch (e) {
			toast.error(e?.message || "Erro ao enviar o teste.");
		}
		setOcupado(false);
	};

	return (
		<div className="space-y-4 border-t pt-4">
			{/* Estado atual */}
			<div className="flex items-center gap-3">
				<div
					className={`flex h-10 w-10 shrink-0 items-center justify-center rounded-lg ${
						status === "ativo"
							? "bg-emerald-100 text-emerald-600 dark:bg-emerald-950"
							: "bg-muted text-muted-foreground"
					}`}
				>
					{status === "ativo" ? (
						<BellRing className="h-5 w-5" />
					) : (
						<BellOff className="h-5 w-5" />
					)}
				</div>
				<div className="min-w-0 flex-1">
					<p className="text-sm font-medium">
						{status === "ativo"
							? "Notificacoes ativas neste aparelho"
							: "Notificacoes desligadas neste aparelho"}
					</p>
					<p className="text-xs text-muted-foreground">
						{status === "carregando" && "Verificando…"}
						{status === "sem-suporte" &&
							"Este navegador nao suporta notificacoes push."}
						{status === "bloqueado" &&
							"As notificacoes estao bloqueadas nas configuracoes do site. Libere e recarregue."}
						{status === "inativo" &&
							"Ative para receber aviso de mensagem nova mesmo com o app fechado."}
						{status === "ativo" &&
							"Voce recebe aviso de mensagem nova mesmo com o app fechado."}
					</p>
				</div>
			</div>

			{/* Acoes */}
			<div className="flex flex-wrap gap-2">
				{status !== "ativo" ? (
					<Button
						type="button"
						onClick={ativar}
						disabled={ocupado || status === "sem-suporte"}
					>
						{ocupado ? (
							<Loader2 className="mr-2 h-4 w-4 animate-spin" />
						) : (
							<BellRing className="mr-2 h-4 w-4" />
						)}
						Ativar notificacoes
					</Button>
				) : (
					<>
						<Button type="button" variant="outline" onClick={testar} disabled={ocupado}>
							<Send className="mr-2 h-4 w-4" />
							Enviar teste
						</Button>
						<Button
							type="button"
							variant="ghost"
							onClick={desativar}
							disabled={ocupado}
						>
							<BellOff className="mr-2 h-4 w-4" />
							Desativar
						</Button>
					</>
				)}
			</div>

			{/* Dica do iPhone */}
			<div className="flex gap-2 rounded-lg border bg-muted/40 p-3 text-xs text-muted-foreground">
				<Smartphone className="mt-0.5 h-4 w-4 shrink-0" />
				<div>
					<p className="mb-1 font-medium text-foreground">No iPhone (iOS 16.4+)</p>
					Primeiro <strong>adicione o app a tela de inicio</strong> pelo Safari
					(Compartilhar → Adicionar a Tela de Inicio). Depois abra{" "}
					<strong>pelo atalho</strong> e toque em <strong>Ativar notificacoes</strong>.
					So assim o iPhone entrega o aviso com o app fechado.
				</div>
			</div>
		</div>
	);
};

export default NotificacoesPush;
